import Vue from 'vue';
import Vuex from 'vuex';

import entry from './modules/entry';

Vue.use( Vuex );
require( 'es6-promise' ).polyfill();

export default new Vuex.Store({
    strict: true,

    modules: {
        entry
    },

    state: {
        copy: window._rootData.copy
    },

    getters: {
        getCopy: state => ( id ) =>
        {
            return state.copy[ id ];
        }
    },

    mutations: {

    },

    actions: {

    }
});
